import React from "react";
import Training from "../../types/Training"; // Import the Training type

const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours}:${minutes.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

export interface TrainingSummaryProps {
  trainings: Training[];
}

const TrainingSummary: React.FC<TrainingSummaryProps> = ({ trainings }) => {
  if (!trainings || trainings.length === 0) {
    return <div>No training data available.</div>;
  }

  let totalDistance = 0;
  let totalElevationGain = 0;
  const hrZoneTimes: { [key: string]: number } = {};

  trainings.forEach((training) => {
    if (training.trainingType === 'RUNNING') {
      totalDistance += training.distance || 0;
      totalElevationGain += training.elevationGain || 0;
    };

    training.trainingParts?.forEach((part) => {
      const zone = part.hrZone || "Unknown";
      hrZoneTimes[zone] = (hrZoneTimes[zone] || 0) + (part.partTime || 0);
    });
  });

  return (
    <div
      style={{
        border: "1px solid #ccc",
        padding: "1rem",
        marginTop: "1rem",
        borderRadius: "8px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        {/* Left Part: General Totals */}
        <div style={{ flex: "1", marginRight: "1rem" }}>
          <h5>General Totals</h5>
          <p>
            <strong>Total Distance:</strong> {totalDistance.toFixed(2)} km
          </p>
          <p>
            <strong>Total Elevation Gain:</strong> {totalElevationGain.toFixed(2)} m
          </p>
        </div>

        {/* Right Part: HR Zone Times */}
        <div style={{ flex: "1", marginLeft: "1rem" }}>
          <h5>HR Zone Times</h5>
          <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
            {Object.entries(hrZoneTimes).map(([zone, time]) => (
              <li key={zone}>
                Zone {zone}: {formatTime(time)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TrainingSummary;
export {};